// src/pages/Invoices.js
import React from 'react';
import InvoicesContainer from '../components/invoices';

const Invoices = () => {
  return <InvoicesContainer />;
};

export default Invoices;